module.exports = __webpack_public_path__ + "img/pilcrow-01.e48d0c15.svg";